// addEventToTrip — pure builder that appends a manual event to its trip list.
//
// Extracted verbatim from `EditTripModal.js` (the `setEditedTrip` updater inside
// `handleAddManualEvent`, `{ ...prev, [config.listKey]: [...(prev[config.listKey]
// || []), newEvent] }`) as part of the behavior-preserving refactor (issue #240).
// It immutably builds the next trip with `newEvent` appended to the list named by
// `config.listKey`, defaulting a missing/falsy list to `[]` before appending.
//
// Totality preserved exactly: the `(prev[config.listKey] || [])` fallback is
// reproduced verbatim, and — matching the source — `config` is assumed defined
// (the source reached this point only past its `if (!config)` early-return). The
// `setShowAddEvent` / `setNewEventType` form-reset side effects stay in the
// hook/container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Returns the next edited trip with `newEvent` appended to `config.listKey`.
 *
 * @param {Object} editedTrip - The current edited-trip working copy.
 * @param {{ listKey: string }} config - The event type config (provides `listKey`).
 * @param {Object} newEvent - The event object to append.
 * @returns {Object} The next edited-trip object.
 */
export function addEventToTrip(editedTrip, config, newEvent) {
  return {
    ...editedTrip,
    [config.listKey]: [...(editedTrip[config.listKey] || []), newEvent]
  };
}

export default addEventToTrip;
